import styled from "@emotion/styled";
import { GelLabel, GelParagraph } from "@tal-gel/components";

const Avatar = ({ imageName, _onClick, active, name, label, description }) => {
  const SAvatarContainer = styled.div({
    height: 220,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  });

  const SAvatar = styled.img(
    {
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        cursor: "pointer",
        transform: `scale(1.05)`,
      },
    },
    (props) => ({
      width: props.active ? 200 : 120,
      height: props.active ? 200 : 120,
    })
  );

  const SText = styled.div({
    paddingTop: 40,
  });
  return (
    <>
      <SAvatarContainer>
        <SAvatar
          alt={name}
          active={active}
          alt={name}
          src={`${process.env.PUBLIC_URL}/images/humans/${imageName}`}
          onClick={_onClick}
        />
      </SAvatarContainer>
      <SText>
        {active ? (
          <>
            <GelLabel>
              {label} <br /> {description}
            </GelLabel>
          </>
        ) : (
          <GelParagraph>
            {" "}
            {label} <br /> {description}
          </GelParagraph>
        )}
      </SText>
    </>
  );
};

export default Avatar;
